import { imagerySchema } from "@/schemas/imagery-schema";
import { IFetchImageryResult, IImageryFilter } from "@/types/imagery-type";

export const fetchImagery = async (
	filter: IImageryFilter,
): Promise<IFetchImageryResult> => {
	if (!filter)
		return {
			isLoading: true,
			error: null,
			imageryData: [],
		};

	try {
		const res = await fetch(
			`https://kuwait.exelys.io/tmp_raster/${filter}/${filter}.json`,
		);

		if (!res.ok) {
			throw new Error("Une erreur est survenue");
		}

		const data = await res.json();

		const validatedData = imagerySchema.parse(data);

		return {
			isLoading: false,
			error: null,
			imageryData: validatedData.files,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			imageryData: [],
		};
	}
};
